<template>
  <h1 class="movie_title">🎬 MovieDesk</h1>
  <router-view />
</template>

<script>

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
}
.movie_title{
  font-size: 2.2rem;
  margin-top: 2rem;
  margin-bottom: 4rem;
  color: #fff;
}
</style>
